import { Dispatch } from 'redux';

import { fetcher } from '../../lib/request';

import { Currency } from '../../models/Hotels/Currency';

const HOTELS_HOST = process.env.REACT_APP_HOTELS_HOST;
const HOTELS_KEY = process.env.REACT_APP_HOTELS_KEY;

export const CURRENCIES_REQUEST = 'HOTELS_CURRENCIES_REQUEST';
export const CURRENCIES_RESPONSE = 'HOTELS_CURRENCIES_RESPONSE';
export const CURRENCIES_ERROR = 'HOTELS_CURRENCIES_ERROR';

export const SET_CURRENCY = 'HOTELS_SET_CURRENCY';

export const getCurrenciesAction = () => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: CURRENCIES_REQUEST
    });

    try {
        const response = await fetcher(`${HOTELS_HOST}/v3/currencies`)
            .auth(`Basic ${HOTELS_KEY}`)
            .json();

        dispatch({
            type: CURRENCIES_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: CURRENCIES_ERROR,
            error
        });
    }
};

export const setCurrencyAction = (currency: Currency) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_CURRENCY,
        currency
    });
};



// WEBPACK FOOTER //
// ./src/actions/Hotels/currencies.ts